import 'typeface-muli'
import './src/styles/index.css'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './src/App'

ReactDOM.render(<App/>, document.getElementById('root'))